import { useEffect } from 'react';

const useDisableNativeGestures = () => {
  useEffect(() => {
    const onGestureStart = (e) => {
      e.preventDefault();
    };
    const onGestureChange = (e) => {
      e.preventDefault();
    };
    document.addEventListener("gesturestart", onGestureStart);
    document.addEventListener("gesturechange", onGestureChange);
    return () => {
      document.removeEventListener("gesturestart", onGestureStart);
      document.removeEventListener("gesturechange", onGestureChange);
    };
  }, []);
};

export { useDisableNativeGestures };
//# sourceMappingURL=useDisableNativeGestures.js.map
